<template>
  <section class="bg-grey-oficial py-5">
    <b-container class="py-5">
      <!-- title -->
      <div class="w-100">
        <h1 class="text-purple mb-4">
          <span class="font-weight-light">O que</span> estão falando de nós.
        </h1>
      </div>

      <!-- depo -->
      <carousel
        :responsive="{
          0: {
            items: 2
          },
          960: {
            items: 4
          }
        }"
        :autoplay="true"
        :nav="false"
        :dots="false"
      >
        <div
          v-for="depo in depoBox"
          :key="depo.id"
          class="bg-grey-oficial p-3 d-flex flex-column align-items-left rounded mx-2"
        >
          <!-- avatar -->
          <img
            class="img-fluid img-press p-xl-5 p-lg-0 p-md-0 p-sm-0 p-4 mb-4"
            :src="require(`@/assets/images/${depo.avatar}`)"
            id="um"
          />

          <!-- <img 
            class="img-fluid img-press p-xl-0 p-lg-0 p-md-0 p-sm-4 p-4 mb-4"
             :src="require(`@/assets/images/${depo.avatar}`)"
             style="max-width: 100%;"
          />-->

          <!-- depo text -->
          <p
            class="text-grey text-left font-weight-bold mb-0"
            style="line-height: 20px;"
            v-html="depo.text"
          />
          <!-- name -->
          <p
            class="text-grey text-left font-weight-light"
            style="line-height: 18px; font-size: 90%; margin-top: 8px"
            v-html="depo.name"
          />
        </div>
      </carousel>
    </b-container>
  </section>
</template>

<script>
import carousel from "vue-owl-carousel";
export default {
  components: {
    carousel
  },
  data: () => {
    return {
      depoBox: [
        {
          avatar: "l1.png",
          text:
            '"Startup que promete vender carro em 50 minutos abre loja em Curitiba"',
          name:
            '"Diferente de plataformas que funcionam como um portal de classificados, a Vaapty atua como intermediadora, tentando negociar o melhor preço. O pagamento também é feito por dentro da plataforma.'
        },
        {
          avatar: "l2.png",
          text:
            '"Start-ups prometem encontrar comprador para o seu carro em menos de 1 hora"',
          name:
            '"Vender um carro usado pode exigir tempo e paciência, e alguns empresários viram aí uma oportunidade de negócio: aproximar vendedores de possíveis compradores. Criaram start-ups que usam sites e aplicativos de celular e prometem encontrar interessados no veículo em menos de uma hora"'
        },
        {
          avatar: "l3.png",
          text:
            '"Criadores de aplicativo garante que podem vender seu carro em apenas 50 minutos"',
          name:
            '"A simplificação do processo que antigamente era complexo e trabalhoso deu certo e a promessa da venda rápido tornou-se o principal slogan dos criadores da empresa"'
        },
        {
          avatar: "l4.png",
          text:
            '"A Vaapty avalia e cuida dos processos de documentação dos veículos"',
          name:
            '"A regularização da documentação do veículo também é realizada pela empresa. “Auxiliamos nos processos de financiamentos e até na parte de dívidas atrasadas”, afirma."'
        }
      ]
    };
  }
};
</script>



<style lang="scss" scoped>
$dimensions: 100px;
.avatar-dimensions {
  width: #{$dimensions} !important;
  height: #{$dimensions} !important;
}

@mixin transitionMixin($transition-time) {
  transition: $transition-time + s ease !important;
  -moz-transition: $transition-time + s all ease !important;
  -o-transition: $transition-time + s all ease !important;
  -webkit-transition: $transition-time + s all ease !important;
}

.img-press {
  @include transitionMixin(0.3);
  opacity: 0.6;
  &:hover {
    opacity: 0.85;
  }
}

.press {
  min-height: 50vh;
}
</style>
